import { Map } from 'immutable';
import { camelizeKeys } from 'humps';
import parseISO from 'date-fns/parseISO';
import getTime from 'date-fns/getTime';

import {
  SURVEYS__CREATE,
  SURVEYS__DELETE,
  SURVEYS__GET,
  SURVEYS__GET_TAGGED,
  SURVEYS__FETCH,
  SURVEYS__FETCH_ACTIVE,
  SURVEYS__FETCH_HASH,
  SURVEYS__FETCH_RECENT,
  SURVEYS__PATCH,
  SURVEYS__UPDATE,
  SURVEYS__UPDATE_ACTION,
  SURVEYS__UPDATE_ACTION__PUBLISH,
  SURVEYS__FETCH_FRAUD_DETECTION_SETTINGS,
  SURVEYS__UPDATE_FRAUD_DETECTION_SETTINGS,
  SURVEY_EDITOR__RESET,
  SURVEYS_REVERSE_LOOKUP__FETCH,
  SURVEYS__RESET,
  USER__LOG_OFF,
} from '../constants';
import { getBeginType, getErrorType } from '../selectors';

import { fromRubyToImmutable, mergeJsonArray, patchIn, pipe } from '../../util';

const defaultState = new Map();

const parseTime = pipe(parseISO, getTime);

const parseDates = (rawSurvey) => {
  const { createdAt, latestResponseAt, publishedAt, ...survey } = camelizeKeys(rawSurvey);
  return {
    ...survey,
    createdAt: parseTime(createdAt),
    latestResponseAt: parseTime(latestResponseAt),
    publishedAt: parseTime(publishedAt),
  };
};

const setFraudDetectionSetting = (state, surveyId, settingId, nextSetting) => {
  const index = state
    .getIn([surveyId, 'fraudDetectionSettings'])
    .findIndex((item) => item.get('id') === settingId);
  return state.setIn([surveyId, 'fraudDetectionSettings', index, 'setting'], nextSetting);
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SURVEYS__CREATE:
    case SURVEYS__GET:
    case SURVEYS__PATCH:
    case SURVEYS__UPDATE:
    case SURVEYS__UPDATE_ACTION:
    case SURVEYS__UPDATE_ACTION__PUBLISH:
      return patchIn(state, action.data.id, parseDates(action.data));
    case SURVEYS__FETCH:
    case SURVEYS__GET_TAGGED:
    case SURVEYS_REVERSE_LOOKUP__FETCH:
      return mergeJsonArray(defaultState, action.data.map(parseDates));
    case SURVEYS__FETCH_RECENT:
      return mergeJsonArray(state, action.data.map(parseDates));
    case SURVEYS__FETCH_ACTIVE: {
      const { survey } = action.data;
      return patchIn(state, survey.id, parseDates(survey));
    }
    case SURVEYS__FETCH_HASH: {
      const { dirtyHash, surveyId } = camelizeKeys(action.data);
      return state.setIn([surveyId, 'dirtyHash'], dirtyHash);
    }
    case SURVEYS__FETCH_FRAUD_DETECTION_SETTINGS:
      return state.setIn(
        [action.surveyId, 'fraudDetectionSettings'],
        fromRubyToImmutable(action.data),
      );
    case getBeginType(SURVEYS__UPDATE_FRAUD_DETECTION_SETTINGS): {
      const { surveyId } = action;
      const { id: settingId, setting } = action.data;
      return setFraudDetectionSetting(state, surveyId, settingId, setting);
    }
    case getErrorType(SURVEYS__UPDATE_FRAUD_DETECTION_SETTINGS): {
      const { surveyId, prevSetting } = action;
      const { id: settingId } = action.data;
      return setFraudDetectionSetting(state, surveyId, settingId, prevSetting);
    }
    case SURVEYS__DELETE:
    case SURVEY_EDITOR__RESET:
    case SURVEYS__RESET:
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
};
